import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ClearIcon from '@material-ui/icons/Clear';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import InfoIcon from '@material-ui/icons/Info';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import Alert from '@material-ui/lab/Alert';
import * as React from 'react';
import { useState } from 'react';
import api from '../../../store/api';
import SecondaryMenu from '../../shared/SecondaryMenu';
import { useForm, Controller } from "react-hook-form";
import { withRouter } from 'react-router-dom';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import DeletePopUp from '../../shared/DeletePopUp';
import { tr } from 'date-fns/locale';
// import fil from 'date-fns/esm/locale/fil/index.js';
import { RadioButtonChecked, Tune } from '@material-ui/icons';
import { color } from 'html2canvas/dist/types/css/types/color';
import ManageUsers from '../../ManageUsers/ManageUsers';
import logo from '../../../assets/icons/warning.png'

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

interface ProfilePermission {
    userProfilePermissionId: string,
    applicationPermissionId: string,
    userProfileId: string,
    createdBy: string,
    modifiedBy: string,
    applicationPermissionName: string,
    checked: boolean | null,
    isAdmin: boolean | null,
    scope: number | null,
    categoryId: string,
    categoryName: string,
    appPermissionRequireScope: boolean | null,
    appPermissionIsInternal: boolean | null,
    appPermDisplayName: string,
    appPermDescription: string,
    role: string,
    subName: string,
};

interface ProfileProps {
    userProfileId: string,
    name: string,
    createdOn: string,
    modifiedOn: string,
    createdBy: string,
    modifiedBy: string,
    deleted: boolean,
    customerLocationId: string,
    selected: boolean,
    idleTimeInMinutes: string,
    logOutTimeOutInMinutes: string,
    checked: boolean | null,
    warningchecked: boolean | null,
};

interface LocationProps {
    locationId: string,
    name: string,
    shortName: string,
    type: number,
    typeName: string,
    customerId: string,
    deleted: boolean,
    isEnabled: boolean,
    isAgedCare: true,
    isEventMedical: true,
    isPatientTransport: true,
    isSMABase: true,
};
interface CustomerProps {
    customerId: string,
    name: string,
    checked: boolean | null,
};

const maxMinutes = 999999;

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            className='tabMenu'
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: any) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme: any) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        height: 'auto',
        width: '100%',
        alignItems: "flex-start",

    },
    revertToSavedButton: {
        marginRight: '10px !important',
        height: 43,
        backgroundColor: '#DBDBDB',
        color: '#000',
    },
    deleteButton: {
        marginRight: '10px !important',
        height: 43,
        backgroundColor: '#DBDBDB',
        color: '#000',
    },
    saveButton: {
        marginRight: '10px !important',
        height: 43,
    },
    tabs: {
        backgroundColor: '#F4F4F4',
        alignItems: 'flex-start',
        width: 252,
        minWidth: 252,
        height: 'inherit',
        '& .Mui-selected': {
            backgroundColor: 'rgba(51, 51, 51, 0.13)'
        }
    },
    tabsMain: {
        backgroundColor: '#3F4E61',
        alignItems: 'flex-start',
        width: 252,
        minWidth: 252,
        height: 'inherit',
        '& .Mui-selected': {
            backgroundColor: '#576475'
        },
        '& .MuiTabScrollButton-root': {
            display: 'none'
        },
        '& .MuiTabs-indicator': {
            display: 'none'
        }
    },
    icon: {
        width: 8,
        height: 14,
    },
    alertRoot: {
        marginTop: 24,
    },
    tabItem: {
        maxWidth: 252,
        minHeight: 44,
        color: '#000',
        paddingLeft: 23,
        '& .MuiTab-wrapper': {
            width: 240,
            alignItems: "center",
            maxHeight: 44,
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row-reverse"
        },

    },
    tabItemMain: {
        maxWidth: 252,
        minHeight: 44,
        color: '#FFFFFF',
        opacity: 1,
        paddingLeft: 22,
        paddingTop: 10,
        paddingBottom: 12,
        '& .MuiTab-wrapper': {
            width: 240,
            alignItems: "flex-start",
            //maxHeight: 44,
            display: "flex",
            textAlign: "left",
            color: '#FFFFFF',
        },
    },
    tabItemChild: {
        maxWidth: 252,
        minHeight: 44,
        marginLeft: 20,
        color: '#FFFFFF',
        opacity: 1,
        paddingLeft: 22,
        paddingTop: 10,
        paddingBottom: 12,
        '& .MuiTab-wrapper': {
            width: 240,
            alignItems: "flex-start",
            //maxHeight: 44,
            display: "flex",
            textAlign: "left",
            color: '#FFFFFF',
        },
    },
    categorySubMenu: {
        fontSize: 12,
        color: '#979797',
        paddingLeft: 22,
        paddingTop: 20,
        paddingBottom: 20
    },
    addProfile: {
        color: '#02489D',
        // marginLeft: '10px',
        height: 55,
        paddingTop: 10,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 23
    },
    subHeading: {
        padding: '0px 10px 0px 0px',
        fontSize: 28,
        fontWeight: 'normal',
    },
    headingTop: {
        fontSize: 36,
        padding: theme.spacing(5, 0, 5, 0),
        paddingLeft: 40,
        fontWeight: 900,
        verticalAlign: 'middle',
        borderBottom: '1px solid #979797',
    },
    privilages: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    tabPanel: {
        width: '100%',
    },
    addProfileSpan: {
        padding: '5px 0px 10px 0px',
        // marginTop: 3,
        fontSize: 18

    },
    primaryIcon: {
        color: '#000',
    },
    addUserIcon: {
        marginRight: 5,
    },
    secondaryMenu: {
        height: '100%',
    },
    buttons: {
        display: 'flex',
    },
    headingThree: {
        color: '#949494',
        fontWeight: 'normal',
        fontSize: 14,
    },
    textFieldRoot: {
        width: '100%',
        '& .MuiOutlinedInput-root': {

        },
        '& .MuiOutlinedInput-input': {
            padding: '0px 10px',
        },
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e6e6e6"
        },
        borderRadius: '5px',
        border: '0px',
    },
    textFieldInput: {
        backgroundColor: '#e6e6e6',
        borderRadius: '0px',
        height: 39,
        width: 357,
        border: '0px',
        color: '#010B18',
    },
    warning: {
        color: 'red',
        marginLeft: 28
    },
    subPrivilegeList: {
        fontFamily: "'Lato', sans-serif",
        padding: "10px 0px",
        paddingLeft: "28px",
        '& .listSection': {
            padding: "10px 0px",
            '& .title': {
                fontSize: "15px",
                fontWeight: 400,
                color: "#949494",
                paddingBottom: "12px",
            },
            '& .body': {
                '& .list': {
                    '& .MuiFormControlLabel-root': {
                        margin: "0px",
                        '& .MuiCheckbox-root': {
                            padding: "2px",
                            paddingRight: "10px",
                        },
                        '& .MuiTypography-body1': {
                            fontSize: "15px",
                            fontWeight: 400,
                        },
                    },
                },
            },
        },
    },
}));
const StarIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" style={{ marginRight: 5 }}>
            <path id="_copy" data-name="* copy" d="M7.961,10,9.444,8.9,7.056,5.658,11,4.306,10.276,2.6,6.4,4.021V0H4.487V4.021L.651,2.6,0,4.306,3.836,5.658,1.484,8.9,3.112,10,5.464,6.584Z" fill="#f4b827" />
        </svg>
    );
}
function UserProfile(): JSX.Element {

    const { handleSubmit: handleSubmitAdd, control: controlAddForm, errors: errorsAddForm } = useForm();
    const classes = useStyles();
    const [currProfileId, setCurrProfileId] = React.useState("");
    const [currProfileCatId, setCurrProfileCatId] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [isInternal, setIsInternal] = React.useState(true);
    const [profileName, setProfileName] = React.useState("");
    const [idleTimeInMinutes, setIdleTimeInMinutes] = React.useState("");
    const [logOutTimeOutInMinutes, setLogOutTimeOutInMinutes] = React.useState("");
    const [profileList, setProfileList] = useState<ProfileProps[]>([]);
    const [profileListManageuser, setProfileListManageuser] = useState<ProfileProps[]>([]);
    const [locationList, setLocationList] = useState<LocationProps[]>([]);
    const [profileFeaturesList, setProfileFeaturesList] = useState<ProfilePermission[]>([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [addingProfileErrorMessage, setAddingErrorMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [confirmationDialog, setConfirmationDialog] = useState(false);
    const [selecteduser, setselecteduser] = useState(false);
    const [warning, setWarning] = useState(false);
    const [showmanageuser, setshowmanageuser] = useState(false);
    const [savebuttondisable, setsavebuttondisable] = useState(false);
    const [show, setshow] = useState(false);
    const [reviewPCR, setReviewPCR] = useState(false);
    const [cgReviewPCR, setCgReviewPCR] = useState(false);
    const [customerlst, setcustomerlst] = useState<CustomerProps[]>([]);
    const [Customer, setCustomer] = React.useState(false);
    const [Location, setLocation] = React.useState(false);
    React.useEffect(() => {
        getCustomers();
        getLocations();

    }, []);

    let profileLists: any = false;
    //get profiles
    const getProfiles = async (locationId: any, IsCustomer: boolean): Promise<ProfileProps[]> => {
        let dataModal = {
            locationId: locationId == "SMA" ? null : locationId,
            version: Math.random().toString() + Math.random().toString() + Math.random().toString(),
            customer: IsCustomer
        };

        let profileList: ProfileProps[] = [];
        clearCache();
        await api.getUserProfiles('', dataModal)
            .then(res => {
                setProfileList([]);
                if (res !== null && res.data !== null && res.data.model !== null) {
                    profileList = res.data.model;
                    setProfileList(profileList);
                }
            })
            .catch(error => {
                setProfileList([]);
                setErrorMessage('Error while getting profiles: ' + error);
            });
        return profileList;
    }
    const getProfilesManageuser = async (locationId: any, profileId: any): Promise<ProfileProps[]> => {
        let dataModal = {
            locationId: locationId == "SMA" ? null : locationId,
            userProfileId: profileId,
            version: Math.random().toString() + Math.random().toString() + Math.random().toString(),
            customer: Customer
        };
        let profileList: ProfileProps[] = [];
        clearCache();
        await api.getUserProfilesmanageuser('', dataModal)
            .then(res => {
                setProfileListManageuser([]);
                if (res !== null && res.data !== null && res.data.model !== null) {
                    profileList = res.data.model;
                    setProfileListManageuser(profileList);
                    var val = profileLists;
                    var countlst = profileList.filter(x => x.checked === true).length;
                    if (val === true && countlst > 0) {
                        setWarning(true)
                    }
                    else {
                        setWarning(false)
                    }
                }
                else {
                    setProfileList([]);
                    setWarning(false);
                }
            })
            .catch(error => {
                setProfileList([]);
                setErrorMessage('Error while getting profiles: ' + error);
            });
        return profileList;
    }

    //get locations
    const getLocations = async (): Promise<void> => {
        clearCache();
        await api.getLocationsForUserProfiles('')
            .then(async res => {
                if (res !== null && res.data !== null && res.data.model !== null) {
                    let locations: LocationProps[] = res.data.model;
                    setLocationList(locations);
                    if (locations.length > 0) {
                        setCurrProfileCatId("SMA");
                        let profiles = await getProfiles("SMA", false);
                        if (profiles.length > 0) {
                            setCurrProfileId(profiles[0].userProfileId);
                            setProfilePermissions(profiles[0].userProfileId);
                            setProfileName(profiles[0].name);
                            setIdleTimeInMinutes(profiles[0].idleTimeInMinutes);
                            setLogOutTimeOutInMinutes(profiles[0].logOutTimeOutInMinutes);
                            getProfilesManageuser("SMA", profiles[0].userProfileId)
                        }
                    }
                }
            })
            .catch(error => {
                setErrorMessage('Error while getting profiles: ' + error);
                setLocationList([]);
            });
    }
    const getCustomers = async (): Promise<void> => {
        clearCache();
        await api.getCustomerForUserProfiles('')
            .then(async res => {
                if (res !== null && res.data !== null && res.data.model !== null) {
                    let customers: CustomerProps[] = res.data.model;
                    setcustomerlst(customers);
                }
            })
            .catch(error => {
                setErrorMessage('Error while getting profiles: ' + error);
                setcustomerlst([]);
            });
    }
    //get profile permissions
    const getProfilePermissions = async (profileId: string): Promise<void> => {
        setshow(false);
        var lst = null;
        clearCache();
        await api.getProfilePermissions('profileId=' + profileId + "&version=" + Math.random() + Math.random() + Math.random())
            .then(res => {
                if (res !== null && res.data !== null && res.data.model !== null) {
                    let _permsList: ProfilePermission[] = res.data.model;
                    if (_permsList !== null) {
                        setProfileFeaturesList(_permsList);
                        var loc = currProfileCatId;
                        if (loc === "" || loc === "SMA") {
                            lst = _permsList.filter(x => x.applicationPermissionName === "SMAUserProfiles")
                        }
                        else {
                            lst = _permsList.filter(x => x.applicationPermissionName === "UserProfiles")
                        }
                        for (let item of lst) {
                            if (item.scope == 1) {
                                setselecteduser(true)
                            }
                            else {
                                setselecteduser(false)
                            }
                        }
                        var lst = null;
                        if (loc === "" || loc === "SMA") {
                            lst = _permsList.filter(x => x.applicationPermissionName === "SMAAdminManageUsers")
                        }
                        else {
                            lst = _permsList.filter(x => x.applicationPermissionName === "ManageUsers")
                        }
                        for (let item of lst) {
                            if (item.checked == true) {
                                profileLists = true
                                setshowmanageuser(true)
                            }
                            else {
                                profileLists = false
                                setshowmanageuser(false)
                            }
                        }
                        _permsList.filter(p => p.applicationPermissionName === "SMAScheduleTransfer" || p.applicationPermissionName === "ScheduleTransfer").map((x: any, i) => {
                            var val = x.checked;

                            if (val === true) {
                                setshow(true);
                                resetMessages();
                            }
                            else{
                                setshow(false);
                            }
                            return;
                        }
                        )
                        if (loc === "" || loc === "SMA") {
                            _permsList.filter(p => p.applicationPermissionName === "SMAViewPCR").map((x: any, i) => {
                                var val = x.checked;

                                if (val === true) {
                                    setReviewPCR(true);
                                    resetMessages();
                                }
                                if (val === false) {
                                    setReviewPCR(false);
                                    resetMessages();
                                }
                                return;
                            }
                            )
                            _permsList.filter(p => p.applicationPermissionName === "SMAReviewPCR").map((x: any, i) => {
                                var val = x.checked;

                                if (val === true) {
                                    setCgReviewPCR(true);
                                    resetMessages();
                                }
                                if (val === false) {
                                    setCgReviewPCR(false);
                                    resetMessages();
                                }
                                return;
                            }
                            )
                        }
                        else {
                            _permsList.filter(p => p.applicationPermissionName === "ViewPCR").map((x: any, i) => {
                                var val = x.checked;

                                if (val === true) {
                                    setReviewPCR(true);
                                    resetMessages();
                                }
                                if (val === false) {
                                    setReviewPCR(false);
                                    resetMessages();
                                }
                                return;
                            }
                            )
                            _permsList.filter(p => p.applicationPermissionName === "ReviewPCR").map((x: any, i) => {
                                var val = x.checked;

                                if (val === true) {
                                    setCgReviewPCR(true);
                                    resetMessages();
                                }
                                if (val === false) {
                                    setCgReviewPCR(false);
                                    resetMessages();
                                }
                                return;
                            }
                            )
                        }


                    }
                }
            })

            .catch(error => {
                setErrorMessage('Error while getting profile permissions: ' + error);
            });


    }

    //add new profile
    const addProfile = async (data: any): Promise<void> => {

        let _req: { [index: string]: any } = {};
        _req = {
            name: data.profilename,
            customerLocationId: currProfileCatId == "SMA" ? null : !Customer ? currProfileCatId : null,
            customerId: Customer ? currProfileCatId : null,
            isSMA: currProfileCatId == "SMA" ? true : false
        };

        await api.addProfile('', _req)
            .then(res => {

                if (res.hasError) {
                    setAddingErrorMessage(res.message ?? "An error has occured");
                }
                else {
                    if (res.message !== null)
                        setStatusMessage(res.message);
                    setOpen(false);

                    if (res.userProfileId != null) {
                        getProfiles(currProfileCatId, Customer);
                        updateProfilePermissions(res.userProfileId, res.name ?? profileName);
                    }
                    setProfileName(res?.name ?? '');
                    setIdleTimeInMinutes('0');
                    setLogOutTimeOutInMinutes('0');
                }
            })
            .catch(error => {
                setAddingErrorMessage(error);
            });
    }

    //refresh profile/permissions list
    const updateProfilePermissions = (profileId: string, currProfileName: string) => {
        setCurrProfileId(profileId);
        setProfileName(currProfileName);
        setIdleTimeInMinutes('0');
        setLogOutTimeOutInMinutes('0');
        setProfilePermissions(profileId);
        getProfilesManageuser(currProfileCatId, profileId)
    }

    //open modal
    const handleOpen = () => {
        // setProfileName('');
        // setIdleTimeInMinutes('0');
        // setLogOutTimeOutInMinutes('0');
        setOpen(true);
        setAddingErrorMessage("");
        resetMessages();
    };

    //close modal
    const handleClose = () => {
        setOpen(false);
        resetMessages();
    };

    //clear cache
    const clearCache = () => {
        try {
            if (caches != undefined) {
                caches.keys().then((names) => {
                    names.forEach((name) => {
                        caches.delete(name);
                    });
                });
                //window.location.reload();
            }
        } catch (error) {
            console.log("Error in reading cache.");
        }
    };

    //reset messages
    const resetMessages = () => {
        setErrorMessage('');
        setStatusMessage('');
    }

    //handle profile change event
    const handleProfileTabChange = (event: React.ChangeEvent<{}>, newProfileId: string) => {
        setCurrProfileId(newProfileId);
        setProfilePermissions(newProfileId);
        getProfilesManageuser(currProfileCatId, newProfileId)
        profileList.filter(p => p.userProfileId == newProfileId).map((p) => {
            setProfileName(p.name);
            setIdleTimeInMinutes(p.idleTimeInMinutes);
            setLogOutTimeOutInMinutes(p.logOutTimeOutInMinutes);
        }
        );
        resetMessages();
    };

    //handle profile category change event
    const handleProfileCategoryTabChange = async (event: React.ChangeEvent<{}>, locationId: string) => {
        setCustomer(false);
        setLocation(false);
        setCurrProfileCatId(locationId);
        setIsInternal(locationId == "SMA" ? true : false);
        await getProfiles(locationId, false);
        setCurrProfileId('');
        setProfileFeaturesList([]);
        resetMessages();
    };
    const handleProfileCategoryTabChangeCustomer = async (CustomerId: string) => {
        setCustomer(true);
        setLocation(false);
        setCurrProfileCatId(CustomerId);
        setIsInternal(false);
        await getProfiles(CustomerId, true);
        setCurrProfileId('');
        setProfileFeaturesList([]);
        resetMessages();
    };
    const handleProfileCategoryTabChangeLocation = async (locationId: string) => {
        setCustomer(false);
        setLocation(true);
        setCurrProfileCatId(locationId);
        setIsInternal(false);
        await getProfiles(locationId, false);
        setCurrProfileId('');
        setProfileFeaturesList([]);
        resetMessages();
    };
    //set profile permissions
    const setProfilePermissions = (profile: string) => {
        getProfilePermissions(profile);
    }

    const toggleAdminCheckbox = (event: React.ChangeEvent<HTMLInputElement>, inputId: string | undefined) => {
        var loc = currProfileCatId;
        let _pcrView: boolean | null = null;
        let _pcrReview: boolean | null = null;
        let _pcrCGReview: boolean | null = null;
        setselecteduser(false);
        if (loc === "" || loc === "SMA") {
            for (let itemList of profileFeaturesList) {
                if (itemList.applicationPermissionId === inputId) {
                    if (itemList.checked) {
                        if (itemList.applicationPermissionName === "SMAViewPCR") {
                            _pcrCGReview = false;
                            _pcrReview = false;
                        }
                        if (itemList.applicationPermissionName === "SMAReviewPCR") {
                            _pcrCGReview = false;
                        }
                    }
                    else {
                        if (itemList.applicationPermissionName === "SMACGReviewPCR") {
                            _pcrView = true;
                            _pcrReview = true;
                        }
                        if (itemList.applicationPermissionName === "SMAReviewPCR") {
                            _pcrView = true;
                        }
                    }
                }
            }
        }
        else {
            for (let itemList of profileFeaturesList) {
                if (itemList.applicationPermissionId === inputId) {
                    if (itemList.checked) {
                        if (itemList.applicationPermissionName === "ViewPCR") {
                            _pcrCGReview = false;
                            _pcrReview = false;
                        }
                        if (itemList.applicationPermissionName === "ReviewPCR") {
                            _pcrCGReview = false;
                        }
                    }
                    else {
                        if (itemList.applicationPermissionName === "CGReviewPCR") {
                            _pcrView = true;
                            _pcrReview = true;
                        }
                        if (itemList.applicationPermissionName === "ReviewPCR") {
                            _pcrView = true;
                        }
                    }
                }
            }
        }

        for (let item of profileFeaturesList) {
            if (item.applicationPermissionId === inputId) {
                item.checked = !item.checked;
                if (!item.checked) {
                    item.scope = null;
                    if (item.applicationPermissionName === "SMAScheduleTransfer" || item.applicationPermissionName === "ScheduleTransfer") {
                        setProfileFeaturesList(
                            profileFeaturesList.filter(x => x.role === "Primary" || x.role === "Secondary").map((item) => {
                                if (item.checked == true) {
                                    item.checked = false
                                }
                                return item;
                            })
                        );
                        setshow(false);
                    }

                }
                else {
                    if (item.appPermissionRequireScope)
                        item.scope = 1
                    if (item.applicationPermissionName === "SMAScheduleTransfer" || item.applicationPermissionName === "ScheduleTransfer") {
                        setshow(true);
                    }
                }
                if (loc === "" || loc === "SMA") {
                    if (item.applicationPermissionName === "SMAAdminManageUsers") {
                        if (item.checked === true) {
                            setshowmanageuser(true)
                            setProfileFeaturesList(
                                profileFeaturesList.filter(x => x.applicationPermissionName === "SMAUserProfiles").map((item) => {
                                    if (item.scope == 1) {
                                        item.scope = 2
                                    }
                                    return item;
                                })
                            );
                            const profilelst = profileListManageuser.map((x) => {
                                if (x.checked === true) {
                                    return { ...x, checked: false };
                                }
                                return x;
                            });

                            setProfileListManageuser(profilelst);
                        }
                        else {
                            setshowmanageuser(false)
                            setselecteduser(false)
                        }
                    }
                }
                else {
                    if (item.applicationPermissionName === "ManageUsers") {
                        if (item.checked === true) {
                            setshowmanageuser(true)
                            setProfileFeaturesList(
                                profileFeaturesList.filter(x => x.applicationPermissionName === "UserProfiles").map((x) => {
                                    if (x.scope == 1) {
                                        x.scope = 2
                                    }
                                    return x;
                                }

                                )
                            );
                            const profilelst = profileListManageuser.map((x) => {
                                if (x.checked === true) {
                                    return { ...x, checked: false };
                                }
                                return x;
                            });

                            setProfileListManageuser(profilelst);
                        }
                        else {
                            setshowmanageuser(false)
                            setselecteduser(false)
                        }
                    }
                }
            }


            if (loc === "" || loc === "SMA") {
                if (item.applicationPermissionName === "SMAAdminManageUsers") {
                    if (item.checked === true) {
                        setProfileFeaturesList(
                            profileFeaturesList.map((item) => {
                                if (item.applicationPermissionName === "SMAUserProfiles") {
                                    if (item.checked == false) {
                                        item.scope = 2
                                        item.checked = true
                                    }
                                    return item;
                                } else {
                                    return item;
                                }
                            })
                        );
                    }
                }
                if (item.applicationPermissionName === "SMAViewPCR") {
                    if (_pcrView === true) {
                        item.checked = true;
                        _pcrView = null;
                    }
                }
                if (item.applicationPermissionName === "SMAReviewPCR") {
                    if (_pcrReview === false) {
                        item.checked = false;
                        _pcrReview = null;
                    }
                    else if (_pcrReview === true) {
                        item.checked = true;
                        _pcrReview = null;
                    }
                }
                if (item.applicationPermissionName === "SMACGReviewPCR") {
                    if (_pcrCGReview === false) {
                        item.checked = false;
                        _pcrCGReview = null;
                    }
                    else if (_pcrCGReview === true) {
                        item.checked = true;
                        _pcrCGReview = null;
                    }
                }
                if ((item.applicationPermissionName === "SMAViewPCR") && item.checked === true)
                    setReviewPCR(true);
                else if ((item.applicationPermissionName === "SMAViewPCR") && item.checked === false)
                    setReviewPCR(false);
                if ((item.applicationPermissionName === "SMAReviewPCR") && item.checked === true)
                    setCgReviewPCR(true);
                else if ((item.applicationPermissionName === "SMAReviewPCR") && item.checked === false)
                    setCgReviewPCR(false);

                var countlst = profileListManageuser.filter(x => x.checked === true).length;
                if (item.applicationPermissionName === "SMAAdminManageUsers") {
                    if (item.checked === true && countlst > 0) {
                        setWarning(true)
                    }
                    else {
                        setWarning(false)
                    }
                }

            }
            else {
                if (item.applicationPermissionName === "ManageUsers") {
                    if (item.checked === true) {
                        setProfileFeaturesList(
                            profileFeaturesList.map((item) => {
                                if (item.applicationPermissionName === "UserProfiles") {
                                    if (item.checked == false) {
                                        item.scope = 2
                                        item.checked = true
                                    }
                                    return item;
                                } else {
                                    return item;
                                }
                            })
                        );
                    }
                }
                if (item.applicationPermissionName === "ViewPCR") {
                    if (_pcrView === true) {
                        item.checked = true;
                        _pcrView = null;
                    }
                }
                if (item.applicationPermissionName === "ReviewPCR") {
                    if (_pcrReview === false) {
                        item.checked = false;
                        _pcrReview = null;
                    }
                    else if (_pcrReview === true) {
                        item.checked = true;
                        _pcrReview = null;
                    }
                }
                if (item.applicationPermissionName === "CGReviewPCR") {
                    if (_pcrCGReview === false) {
                        item.checked = false;
                        _pcrCGReview = null;
                    }
                    else if (_pcrCGReview === true) {
                        item.checked = true;
                        _pcrCGReview = null;
                    }
                }
                if ((item.applicationPermissionName === "ViewPCR") && item.checked === true)
                    setReviewPCR(true);
                else if ((item.applicationPermissionName === "ViewPCR") && item.checked === false)
                    setReviewPCR(false);
                if ((item.applicationPermissionName === "ReviewPCR") && item.checked === true)
                    setCgReviewPCR(true);
                else if ((item.applicationPermissionName === "ReviewPCR") && item.checked === false)
                    setCgReviewPCR(false);


                var countlst = profileListManageuser.filter(x => x.checked === true).length;
                if (item.applicationPermissionName === "ManageUsers") {
                    if (item.checked === true && countlst > 0) {
                        setWarning(true)
                    }
                    else {
                        setWarning(false)
                    }
                }
            }

        }
        const _profilePermsList = profileFeaturesList.map(a => ({ ...a }));
        setProfileFeaturesList(_profilePermsList);
        resetMessages();
    }
    //handle permission checkbox click for admin perms
    const toggleAdminCheckboxprofilelist = async (event: React.ChangeEvent<HTMLInputElement>, inputId: string | undefined, inputIds: string) => {
        for (let item of profileListManageuser) {
            if (item.userProfileId === inputId) {
                item.checked = !item.checked;
            }
        }
        if (inputId !== currProfileId) {

            var res = await api.getWarnigmessage(`profileId=${inputId}`);
            if (res.data.message === "Success") {
                setProfileListManageuser(
                    profileListManageuser.map((item) => {
                        if (item.userProfileId === inputId) {
                            if (item.checked == true) {
                                item.warningchecked = true
                            }
                            else {
                                item.warningchecked = false
                            }
                            return item;
                        } else {
                            return item;
                        }
                    })
                );
            }
            else {
                setProfileListManageuser(
                    profileListManageuser.map((item) => {
                        if (item.userProfileId === inputId) {
                            if (item.checked == true) {
                                item.warningchecked = false
                            }
                            return item;
                        } else {
                            return item;
                        }
                    })
                );
            }
        }
        const _profilelist = profileListManageuser.map(a => ({ ...a }));
        var countlst = profileListManageuser.filter(x => x.checked === true).length;
        const _profileFeaturesList = profileFeaturesList.filter(x => x.appPermDisplayName === "Manage users" && x.checked === true).length;
        if (countlst > 0 && _profileFeaturesList > 0) {
            setWarning(true)
        }
        else {
            setWarning(false)
        }
        setProfileListManageuser(_profilelist);
        resetMessages();
    }
    //save profile permissions
    const saveProfilePermissions = async (): Promise<void> => {
        setsavebuttondisable(true);
        let listPermissions = [...profileFeaturesList];
        const profilelist = [...profileListManageuser];

        if (!profileName) {
            setErrorMessage('Profile name cannot be empty');
            setsavebuttondisable(false);
            return;
        }
        try {

            let res = await api.saveProfilePermissions(
                `profileId=${currProfileId}&profileName=${profileName}&idleTimeInMinutesStr=${idleTimeInMinutes}&logOutTimeOutInMinutesStr=${logOutTimeOutInMinutes}`,
                listPermissions)
            if (!res.hasError) {

                let ress = await api.saveuserprofie(
                    `profileId=${currProfileId}&profileName=${profileName}&idleTimeInMinutesStr=${idleTimeInMinutes}&logOutTimeOutInMinutesStr=${logOutTimeOutInMinutes}`,
                    profilelist);
                if (res.message !== null && ress.message !== null)
                    await getProfiles(currProfileCatId, Customer);
                setStatusMessage(res.message);
                setsavebuttondisable(false);
                setOpen(false);
            }
            else {
                setErrorMessage(res.message);
                setsavebuttondisable(false);
            }

        }
        catch (error) {
            setErrorMessage('Error while updating profile permissions: ' + error);
            setsavebuttondisable(false);
        }
    }

    //delete profile
    const deleteProfile = async (): Promise<void> => {

        //update profile

        try {
            let res = await api.deleteUserProfile("profileId=" + currProfileId);
            if (!res.hasError) {
                if (res.message !== null)
                    setStatusMessage(res.message);
                let profiles = await getProfiles(currProfileCatId, Customer);
                if (profiles.length > 0) {
                    setCurrProfileId(profiles[0].userProfileId);
                    setProfilePermissions(profiles[0].userProfileId);
                    setProfileName(profiles[0].name);
                    setIdleTimeInMinutes(profiles[0].idleTimeInMinutes);
                    setLogOutTimeOutInMinutes(profiles[0].logOutTimeOutInMinutes);
                }
                else{
                    setCurrProfileId("")
                }
            }
            else {
                setErrorMessage(res.message);
            }
        }
        catch (error) {
            setErrorMessage('Error while deleting profile: ' + error);
        };
        setConfirmationDialog(false);
    }

    //refresh profile/permissions
    const revertCurrentProfile = async (): Promise<void> => {
        const refreshId = currProfileId;
        setCurrProfileId(refreshId);
        setProfilePermissions(refreshId);
        getProfilesManageuser(currProfileCatId, refreshId)
        profileList.filter(p => p.userProfileId == currProfileId).map((p) => {
            setProfileName(p.name)
            setIdleTimeInMinutes(p.idleTimeInMinutes);
            setLogOutTimeOutInMinutes(p.logOutTimeOutInMinutes);
        });
    }

    const tabHeight: any = document.body.offsetHeight - 185;
    const profileNameChangedHandler = (e: React.ChangeEvent<HTMLInputElement>, inputId: string) => {
        setProfileName(e.target.value);
        resetMessages();
    }

    const profileEditNumberHandler = (e: React.ChangeEvent<HTMLInputElement>, inputId: string) => {
        const value = e.target.value;
        switch (inputId) {
            case 'profileEditIdleTimeInMinutes':
                setIdleTimeInMinutes(value);
                break;
            case 'profileEditLogOutTimeOutInMinutes':
                setLogOutTimeOutInMinutes(value);
                break;
            default:
                break;
        }

    }

    //new profile modal
    const body = (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: 20,
                    marginTop: 20,
                    alignSelf: 'stretch'
                }}>
                    <DialogTitle id="form-dialog-title" ><a style={{ fontSize: 20 }}>New User Profile</a></DialogTitle>
                    <ClearIcon onClick={handleClose} style={{ cursor: "pointer" }} />
                </div>
                <DialogContent>
                    <form onSubmit={handleSubmitAdd(addProfile)}>
                        <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: addingProfileErrorMessage ? 'flex' : 'none', marginBottom: 30 }}>
                            {addingProfileErrorMessage}
                        </Alert>
                        <Controller control={controlAddForm}
                            as={<TextField
                                variant='outlined' placeholder='Profile Name' error={errorsAddForm.profilename !== undefined && errorsAddForm.profilename !== null} helperText={errorsAddForm.profilename ? errorsAddForm.profilename.message : ""} />}
                            name='profilename'
                            rules={{
                                required: "Profile name is required"
                            }}
                        />

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: 25,
                                marginBottom: 25
                            }}
                        >
                            <Button
                                onClick={handleClose}
                                style={{
                                    width: 160,
                                    height: 43,
                                    backgroundColor: '#DBDBDB',
                                    color: '#000',
                                    marginRight: 15
                                }}
                                variant="contained"
                            >
                                Cancel
                            </Button>
                            <Button variant="contained"
                                type="submit"
                                color="primary"
                                style={{
                                    width: 160,
                                    height: 43,

                                }}
                            >

                                Add
                            </Button>

                        </div>
                    </form>
                </DialogContent>

            </Dialog>
        </div>
    );

    //line separator in location tab
    const HorizontalLine = () => {
        return (
            <div
                style={{
                    height: 0,
                    borderTop: '1px solid #D8D8D83B',
                    margin: 0,
                    padding: 0
                }}
            />
        )
    }

    //body color header
    const Heading = ({ text, color }: any) => {
        return (
            <div style={{ color: color, fontWeight: 900, fontSize: 18, marginBottom: 18 }}>{text}</div>
        )
    }

    //body feature description
    const Description = ({ text }: any) => {
        return (
            <div style={{ color: '#7D7D7D', fontSize: 15, paddingLeft: 28 }}>{text}</div>
        )
    }

    //radio button handle
    const handleRadioChange = (event: any, inputId: string | undefined) => {
        let updateValue = Number(event.target.value);
        var ManageUsers = "";
        for (let item of profileFeaturesList) {
            if (item.applicationPermissionId === inputId) {
                item.scope = updateValue;
                item.checked = true;
                if (item.role === "ManageUsers") {
                    if (item.scope == 1) {
                        setselecteduser(true)
                    }
                    else {
                        setWarning(false);
                        setselecteduser(false)
                    }
                    ManageUsers = item.role;
                }
            }
        }

        if (updateValue == 2 && ManageUsers != "") {
            const profilelst = profileListManageuser.map((x) => {
                if (x.checked === true) {
                    return { ...x, checked: false };
                }
                return x;
            });

            setProfileListManageuser(profilelst);
        }
        const _profilePermsList = profileFeaturesList.map(a => ({ ...a }));
        setProfileFeaturesList(_profilePermsList);
        resetMessages();
    };
    //radio button handle
    const handleRadioChangemanageuser = (event: any, inputId: string | undefined) => {
        if (selecteduser === false) {
            setselecteduser(true)
        }
        else {
            setselecteduser(false)
        }
    };
    const useStylesRadio = makeStyles({
        root: {
            '&:hover': {
                backgroundColor: 'transparent',
            }
        },
        icon: {
            borderRadius: '50%',
            width: 18,
            height: 18,
            boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
            backgroundColor: '#f5f8fa',
            '$root.Mui-focusVisible &': {
                outline: '2px auto rgba(19,124,189,.6)',
                outlineOffset: 2,
            },
            'input:hover ~ &': {
                backgroundColor: '#ebf1f5',
            },
            'input:disabled ~ &': {
                boxShadow: 'none',
                background: 'rgba(206,217,224,.5)',
            }
        },
        checkedIcon: {
            backgroundColor: '#ededed',
            '&:before': {
                display: 'block',
                width: 18,
                height: 18,
                backgroundImage: 'radial-gradient(#000,#000 28%,transparent 32%)',
                content: '""',
            },
            'input:hover ~ &': {
                backgroundColor: '#ededed',
            }
        }
    });

    function StyledRadio(props: any) {
        const classes = useStylesRadio();

        return (
            <Radio
                className={classes.root}
                disableRipple
                color="default"
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                {...props}
            />
        );
    }
    const [selection, setselection] = React.useState("");
    function MultipleTab(props: any) {
        const classes = useStyles();
        const [Location, setLocation] = React.useState(false);
        const [LocationId, setLocationId] = React.useState(null);
        const handlecustomerTabChange = async (customerId: string) => {
            if (!Location) {
                setLocation(true);
                setselection(customerId.toString());
            }
            else {
                setLocation(false);
            }
            setLocationList(
                locationList.map((item) => {
                    if (item.customerId === customerId) {
                        if (item.isEnabled) {
                            item.isEnabled = false
                        }
                        else {
                            item.isEnabled = true
                        }
                        return item;
                    } else {
                        return item;
                    }
                })
            );

        };
        return (
            <React.Fragment>
                <Tab key={props.customerId}
                    label={props.name}
                    onClick={(e) => {
                        handlecustomerTabChange(props.customerId);
                        handleProfileCategoryTabChangeCustomer(props.customerId);
                    }}
                    className={classes.tabItemMain}
                    selected={props.customerId === selection}
                    {...a11yProps(props.customerId)}
                    value={props.customerId} />
                <LocationTab
                    locationList={locationList}
                    Location={Location}
                    setLocationId={setLocationId}
                    currProfileCatId={props.currProfileCatId}
                    customerId={props.customerId}
                    selectionvalue={selection}
                />
            </React.Fragment>
        );
    }
    function LocationTab(props: any) {
        const classes = useStyles();
        return (
            <React.Fragment>
                {props.locationList.filter((x: any) => x.customerId === props.customerId && x.isEnabled === false).map((location: any) =>
                    <Tab key={location.locationId}
                        label={location.name}
                        className={classes.tabItemChild}
                        onClick={(e) => {
                            setselection(location.locationId);
                            handleProfileCategoryTabChangeLocation(location.locationId)
                        }}
                        selected={location.locationId === selection}
                        {...a11yProps(location.locationId)}
                        value={location.locationId}
                    >
                    </Tab>
                )
                }
            </React.Fragment>
        );
    }
    return (

        <React.Fragment>
            <div style={{ display: 'flex', alignItems: 'stretch', flexGrow: 1, }}>
                <div style={{ alignSelf: 'stretch', display: 'flex', }}>
                    <SecondaryMenu selectedmenu='User Profiles' />
                </div>

                <div style={{ width: '100%', }}>
                    <div className={classes.headingTop}> User Profiles</div>

                    <div className={classes.root}>

                        <div style={{ display: "flex", flexDirection: 'column', backgroundColor: '#3F4E61', height: tabHeight }}>
                            <Tabs
                                orientation="vertical"
                                variant="scrollable"
                                value={currProfileCatId}
                                onChange={handleProfileCategoryTabChange}
                                aria-label="Vertical tabs"
                                className={classes.tabsMain}>

                                <Tab key={"SMA"}
                                    label={"SMA"}
                                    className={classes.tabItemMain}
                                    {...a11yProps("SMA")}
                                    value={"SMA"} />

                                <div>
                                    <HorizontalLine />
                                </div>

                                {
                                    customerlst.map(cus =>
                                        <MultipleTab
                                            customerId={cus.customerId}
                                            name={cus.name}
                                            locationList={locationList}
                                            currProfileCatId={currProfileCatId}
                                            ontabchange={handleProfileCategoryTabChangeCustomer}
                                            checked={cus.checked}
                                        >

                                        </MultipleTab>

                                    )}
                            </Tabs>
                        </div>

                        {currProfileCatId ?
                            <div style={{ display: "flex", flexDirection: 'column', backgroundColor: '#F4F4F4', height: tabHeight }}>
                                <a className={classes.addProfile} color='primary' onClick={handleOpen} ><ControlPointIcon className={classes.addUserIcon} color="primary" /><span className={classes.addProfileSpan}>Add Profile </span></a>
                                <Tabs
                                    orientation="vertical"
                                    variant="scrollable"
                                    value={currProfileId}
                                    onChange={handleProfileTabChange}
                                    aria-label="Vertical tabs"
                                    className={classes.tabs}
                                    TabIndicatorProps={{
                                        style: {
                                            display: 'none',
                                            width: '100%',
                                            alignItems: 'flex-start'
                                        }
                                    }}
                                >
                                    {profileList.map(profile =>
                                        <Tab key={profile.userProfileId}
                                            label={profile.name}
                                            className={classes.tabItem}
                                            icon={currProfileId === profile.userProfileId ? <ArrowForwardIosIcon style={{ height: 16, }} className={classes.primaryIcon} /> : <ArrowForwardIosIcon style={{ color: '#f4f4f4', height: 14, }} className='forwardIcon' />}
                                            {...a11yProps(currProfileId)}
                                            value={profile.userProfileId}
                                        >
                                        </Tab>)}
                                </Tabs>
                            </div>
                            : null
                        }
                        {
                            currProfileId && profileFeaturesList.length > 0 ?
                                <div className={classes.tabPanel} style={{ maxHeight: tabHeight, overflow: 'auto' }}>
                                    <div>
                                        <div>
                                            <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                                                {errorMessage}
                                            </Alert>
                                            <Alert variant="filled" icon={<InfoIcon />} severity="success" classes={{ root: classes.alertRoot }} style={{ display: statusMessage ? 'flex' : 'none' }}>
                                                {statusMessage}
                                            </Alert>
                                        </div>

                                        <TabPanel value={currProfileId} index={currProfileId}>
                                            <Grid container>
                                                <Grid item lg={6}>
                                                    <h2 className={classes.subHeading}>Privileges</h2>
                                                </Grid>
                                                <Grid item lg={6} alignItems="flex-end">

                                                    <Button className={classes.revertToSavedButton} variant="contained" style={{ marginTop: 23 }} onClick={revertCurrentProfile}>
                                                        Revert To Saved
                                                    </Button>
                                                    <Button className={classes.deleteButton} variant="contained" style={{ marginTop: 23 }} onClick={() => setConfirmationDialog(true)}>
                                                        Delete
                                                    </Button>&nbsp;
                                                    <Button className={classes.saveButton} variant="contained" color="primary" style={{ marginTop: 23 }} disabled={savebuttondisable} onClick={saveProfilePermissions}>
                                                        Save
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            <div>
                                                <div>
                                                    <h3 className={classes.headingThree}><span><StarIcon /></span>NAME</h3>
                                                </div>
                                                <div>
                                                    <TextField
                                                        classes={{ root: classes.textFieldRoot }}
                                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                                        variant='outlined'
                                                        placeholder='Name'
                                                        value={profileName}
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileNameChangedHandler(e, 'profileEditName')}
                                                        id="profileEditName"
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <h3 className={classes.headingThree}>Idle Time (minutes)</h3>
                                                </div>
                                                <div>
                                                    <TextField
                                                        classes={{ root: classes.textFieldRoot }}
                                                        InputProps={{
                                                            classes: { root: classes.textFieldInput },
                                                            inputProps: { max: maxMinutes, min: 0, step: 1 }
                                                        }}
                                                        variant='outlined'
                                                        placeholder='minutes'
                                                        value={idleTimeInMinutes}
                                                        type="number"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileEditNumberHandler(e, 'profileEditIdleTimeInMinutes')}
                                                        id="profileEditIdleTimeInMinutes"
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <h3 className={classes.headingThree}>Logout Time (minutes)</h3>
                                                </div>
                                                <div>
                                                    <TextField
                                                        classes={{ root: classes.textFieldRoot }}
                                                        InputProps={{
                                                            classes: { root: classes.textFieldInput },
                                                            inputProps: { max: maxMinutes, min: 0, step: 1 }
                                                        }}
                                                        variant='outlined'
                                                        placeholder='minutes'
                                                        value={logOutTimeOutInMinutes}
                                                        type="number"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileEditNumberHandler(e, 'profileEditLogOutTimeOutInMinutes')}
                                                        id="profileEditLogOutTimeOutInMinutes"

                                                    />
                                                </div>
                                            </div>
                                            <FormGroup>
                                                <div style={{ borderLeft: '4px solid #577C6D', paddingLeft: 20, marginTop: 30 }}>
                                                    <Heading text="ADMIN FEATURES" color="#577C6D" />
                                                    {
                                                        profileFeaturesList.filter(p => p.categoryName === "Admin Features" && p.appPermissionIsInternal === isInternal && p.role !== "ManageUsers").map((perm, i) =>
                                                            <div>
                                                                <FormControlLabel
                                                                    key={i}
                                                                    control={<Checkbox name={perm.appPermDisplayName}
                                                                        style={{ padding: 4 }}
                                                                        checked={perm.checked ?? false}
                                                                        key={perm.applicationPermissionId}
                                                                        onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, perm.applicationPermissionId)} />}
                                                                    label={perm.appPermDisplayName}
                                                                />
                                                                <Description text={perm.appPermDescription} />
                                                                {
                                                                    perm.appPermissionRequireScope ?
                                                                        <div style={{ paddingLeft: 28 }}>
                                                                            <RadioGroup row value={perm.scope?.toString() ?? null} onChange={(e) => handleRadioChange(e, perm.applicationPermissionId)}>
                                                                                <FormControlLabel value="2" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For any ward in hospital" />
                                                                                <FormControlLabel value="1" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For user’s ward only" />
                                                                            </RadioGroup>
                                                                        </div>
                                                                        : null
                                                                }
                                                                {
                                                                    (perm.applicationPermissionName === "SMAAdminManageUsers" || perm.applicationPermissionName === "ManageUsers") && (showmanageuser === true) ?
                                                                        profileFeaturesList.filter(p => p.categoryName === "Admin Features" && p.appPermissionIsInternal === isInternal && p.role === "ManageUsers").map((perms, i) =>
                                                                            <div style={{ paddingLeft: 28 }}>
                                                                                <RadioGroup row value={perms.scope?.toString() ?? "2"} onChange={(e) => { handleRadioChange(e, perms.applicationPermissionId) }}>
                                                                                    <FormControlLabel value="2" control={<StyledRadio />} label="Having any user profile" /><br></br>
                                                                                    <FormControlLabel value="1" control={<StyledRadio />} label="Having selected user profiles" />
                                                                                </RadioGroup>
                                                                            </div>
                                                                        )
                                                                        : null
                                                                }
                                                                {
                                                                    (perm.applicationPermissionName === "SMAAdminManageUsers" || perm.applicationPermissionName === "ManageUsers") && (selecteduser === true && showmanageuser === true) ?
                                                                        profileListManageuser.map((perms, i) =>
                                                                            <div className={"body"}>
                                                                                <div className={"list"} style={{ marginLeft: "31px" }}>
                                                                                    <FormControlLabel
                                                                                        key={i}
                                                                                        control={<Checkbox name={perms.name}
                                                                                            style={{ padding: 4 }}
                                                                                            checked={perms.checked ? true : false}
                                                                                            key={perm.userProfileId}
                                                                                            onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckboxprofilelist(e, perms.userProfileId, perm.applicationPermissionId)} />}
                                                                                        label={perms.name}
                                                                                    />
                                                                                </div>
                                                                                {perms.warningchecked === true && perms.checked === true ?
                                                                                    <div className={classes.warning}>
                                                                                        <img style={{ marginBottom: -3 }} src={logo} />
                                                                                        <span> This profile has full Manage Users privileges. It could be used to add an account that overrides restrictions.
                                                                                        </span> </div> : null}
                                                                            </div>
                                                                        )
                                                                        : null
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </FormGroup>

                                            <FormGroup>
                                                <div style={{ borderLeft: '4px solid #AE72C0', paddingLeft: 20, marginTop: 30 }}>
                                                    <Heading text="PATIENT TRANSPORT FEATURES" color="#AE72C0" />
                                                    {
                                                        profileFeaturesList.filter(p => p.categoryName === "Patient Transport Features" && p.appPermissionIsInternal === isInternal).map((perm, i) =>
                                                            <div>
                                                                {perm.role === null ?
                                                                    <div>
                                                                        <FormControlLabel
                                                                            key={i}
                                                                            control={<Checkbox name={perm.appPermDisplayName}
                                                                                style={{ padding: 4 }}
                                                                                checked={perm.checked ?? false}
                                                                                key={perm.applicationPermissionId}
                                                                                onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, perm.applicationPermissionId)
                                                                                } />}
                                                                            label={perm.appPermDisplayName}
                                                                        />
                                                                        <Description text={perm.appPermDescription} />
                                                                        {
                                                                            perm.appPermissionRequireScope ?
                                                                                <div style={{ paddingLeft: 28 }}>
                                                                                    <RadioGroup row value={perm.scope?.toString() ?? null} onChange={(e) => handleRadioChange(e, perm.applicationPermissionId)}>
                                                                                        <FormControlLabel value="2" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For any ward in hospital" />
                                                                                        <FormControlLabel value="1" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For user’s ward only" />
                                                                                    </RadioGroup>
                                                                                </div>
                                                                                : null
                                                                        }
                                                                    </div>
                                                                    : null}
                                                                {(perm.applicationPermissionName == "SMAScheduleTransfer" || perm.applicationPermissionName == "ScheduleTransfer") && show == true ?
                                                                    <div className={classes.subPrivilegeList}>
                                                                        <div className={"listSection"}>
                                                                            <div className={"title"}>
                                                                                ACCESS PRIMARY PLANNERS
                                                                            </div>
                                                                            {profileFeaturesList.filter(p => p.appPermissionIsInternal === isInternal && p.role === "Primary").map((permp, i) => (<>

                                                                                <div className={"body"}>
                                                                                    <div className={"list"}>
                                                                                        <FormControlLabel
                                                                                            key={i}
                                                                                            control={<Checkbox name={permp.appPermDisplayName}
                                                                                                style={{ padding: 4 }}
                                                                                                checked={permp.checked ?? false}
                                                                                                key={permp.applicationPermissionId}
                                                                                                onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, permp.applicationPermissionId)} />}
                                                                                            label={permp.appPermDisplayName}
                                                                                        />
                                                                                    </div>

                                                                                </div>
                                                                            </>))}
                                                                        </div>
                                                                        <div className={"listSection"}>
                                                                            <div className={"title"}>
                                                                                ACCESS SECONDARY PLANNERS
                                                                            </div>
                                                                            {profileFeaturesList.filter(p => p.appPermissionIsInternal === isInternal && p.role === "Secondary").map((perms, i) => (<>

                                                                                <div className={"body"}>
                                                                                    <div className={"list"}>
                                                                                        <FormControlLabel
                                                                                            key={i}
                                                                                            control={<Checkbox name={perms.appPermDisplayName}
                                                                                                style={{ padding: 4 }}
                                                                                                checked={perms.checked ?? false}
                                                                                                key={perms.applicationPermissionId}
                                                                                                onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, perms.applicationPermissionId)} />}
                                                                                            label={perms.appPermDisplayName}
                                                                                        />

                                                                                    </div>

                                                                                </div>
                                                                            </>))}
                                                                        </div>
                                                                    </div>
                                                                    : null}
                                                            </div>

                                                        )
                                                    }
                                                </div>
                                            </FormGroup>

                                            <FormGroup>
                                                <div style={{ borderLeft: '4px solid #B75959', paddingLeft: 20, marginTop: 30 }}>
                                                    <Heading text="SECURITY" color="#B75959" />
                                                    {
                                                        profileFeaturesList.filter(p => p.categoryName === "Security" && p.appPermissionIsInternal === isInternal).map((perm, i) =>
                                                            <div>
                                                                <FormControlLabel
                                                                    key={i}
                                                                    control={<Checkbox name={perm.appPermDisplayName}
                                                                        style={{ padding: 4 }}
                                                                        checked={perm.checked ?? false}
                                                                        key={perm.applicationPermissionId}
                                                                        onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, perm.applicationPermissionId)} />}
                                                                    label={perm.appPermDisplayName}
                                                                />
                                                                <Description text={perm.appPermDescription} />
                                                                {
                                                                    perm.appPermissionRequireScope ?
                                                                        <div style={{ paddingLeft: 28 }}>
                                                                            <RadioGroup row value={perm.scope?.toString() ?? null} onChange={(e) => handleRadioChange(e, perm.applicationPermissionId)}>
                                                                                <FormControlLabel value="2" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For any ward in hospital" />
                                                                                <FormControlLabel value="1" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For user’s ward only" />
                                                                            </RadioGroup>
                                                                        </div>
                                                                        : null
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </FormGroup>

                                            {profileFeaturesList.filter(p => p.categoryName === "PCR" && p.appPermissionIsInternal === isInternal && p.subName === null).length > 0 && <FormGroup>
                                                <div style={{ borderLeft: '4px solid #B75959', paddingLeft: 20, marginTop: 30 }}>
                                                    <Heading text="PCR" color="#B75959" />
                                                    {
                                                        profileFeaturesList.filter(p => p.categoryName === "PCR" && p.applicationPermissionName.includes("ViewPCR") && p.appPermissionIsInternal === isInternal && p.subName === null).map((perm, i) =>
                                                            <div>
                                                                <FormControlLabel
                                                                    key={i}
                                                                    control={<Checkbox name={perm.appPermDisplayName}
                                                                        style={{ padding: 4 }}
                                                                        checked={perm.checked ?? false}
                                                                        key={perm.applicationPermissionId}
                                                                        onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, perm.applicationPermissionId)} />}
                                                                    label={perm.appPermDisplayName}
                                                                />
                                                                <Description text={perm.appPermDescription} />
                                                                {
                                                                    perm.appPermissionRequireScope ?
                                                                        <div style={{ paddingLeft: 28 }}>
                                                                            <RadioGroup row value={perm.scope?.toString() ?? null} onChange={(e) => handleRadioChange(e, perm.applicationPermissionId)}>
                                                                                <FormControlLabel value="2" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For any ward in hospital" />
                                                                                <FormControlLabel value="1" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For user’s ward only" />
                                                                            </RadioGroup>
                                                                        </div>
                                                                        : null
                                                                }
                                                                {/* -------------- */}
                                                                {reviewPCR && profileFeaturesList.filter(p1 => p1.subName === "ViewPCR" && perm.applicationPermissionName.includes("ViewPCR") && p1.appPermissionIsInternal === isInternal).map((perm1, i1) =>
                                                                    <div style={{ marginLeft: 30 }}>
                                                                        <FormControlLabel
                                                                            key={i1}
                                                                            control={<Checkbox name={perm1.appPermDisplayName}
                                                                                style={{ padding: 4 }}
                                                                                checked={perm1.checked ?? false}
                                                                                key={perm1.applicationPermissionId}
                                                                                onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, perm1.applicationPermissionId)} />}
                                                                            label={perm1.appPermDisplayName}
                                                                        />
                                                                        <Description text={perm1.appPermDescription} />
                                                                        {
                                                                            perm1.appPermissionRequireScope ?
                                                                                <div style={{ paddingLeft: 28 }}>
                                                                                    <RadioGroup row value={perm1.scope?.toString() ?? null} onChange={(e) => handleRadioChange(e, perm1.applicationPermissionId)}>
                                                                                        <FormControlLabel value="2" control={<StyledRadio disabled={!perm1.checked ?? true} />} label="For any ward in hospital" />
                                                                                        <FormControlLabel value="1" control={<StyledRadio disabled={!perm1.checked ?? true} />} label="For user’s ward only" />
                                                                                    </RadioGroup>
                                                                                </div>
                                                                                : null
                                                                        }
                                                                        {/* ---------------- */}
                                                                        {cgReviewPCR && profileFeaturesList.filter(p2 => p2.subName === "ReviewPCR" && perm.applicationPermissionName.includes("ViewPCR") && p2.appPermissionIsInternal === isInternal).map((perm2, i2) =>
                                                                            <div style={{ marginLeft: 30 }}>
                                                                                <FormControlLabel
                                                                                    key={i2}
                                                                                    control={<Checkbox name={perm2.appPermDisplayName}
                                                                                        style={{ padding: 4 }}
                                                                                        checked={perm2.checked ?? false}
                                                                                        key={perm2.applicationPermissionId}
                                                                                        onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, perm2.applicationPermissionId)} />}
                                                                                    label={perm2.appPermDisplayName}
                                                                                />
                                                                                <Description text={perm2.appPermDescription} />
                                                                                {
                                                                                    perm2.appPermissionRequireScope ?
                                                                                        <div style={{ paddingLeft: 28 }}>
                                                                                            <RadioGroup row value={perm2.scope?.toString() ?? null} onChange={(e) => handleRadioChange(e, perm2.applicationPermissionId)}>
                                                                                                <FormControlLabel value="2" control={<StyledRadio disabled={!perm2.checked ?? true} />} label="For any ward in hospital" />
                                                                                                <FormControlLabel value="1" control={<StyledRadio disabled={!perm2.checked ?? true} />} label="For user’s ward only" />
                                                                                            </RadioGroup>
                                                                                        </div>
                                                                                        : null
                                                                                }
                                                                            </div>
                                                                        )}
                                                                        {/* ---------------- */}
                                                                    </div>
                                                                )}
                                                                {/* -------------- */}
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        profileFeaturesList.filter(p => p.categoryName === "PCR" && p.applicationPermissionName.includes("SubmitPatientCareRecords") && p.appPermissionIsInternal === isInternal && p.subName === null).map((perm, i) =>
                                                            <div>
                                                                <FormControlLabel
                                                                    key={i}
                                                                    control={<Checkbox name={perm.appPermDisplayName}
                                                                        style={{ padding: 4 }}
                                                                        checked={perm.checked ?? false}
                                                                        key={perm.applicationPermissionId}
                                                                        onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, perm.applicationPermissionId)} />}
                                                                    label={perm.appPermDisplayName}
                                                                />
                                                                <Description text={perm.appPermDescription} />
                                                                {
                                                                    perm.appPermissionRequireScope ?
                                                                        <div style={{ paddingLeft: 28 }}>
                                                                            <RadioGroup row value={perm.scope?.toString() ?? null} onChange={(e) => handleRadioChange(e, perm.applicationPermissionId)}>
                                                                                <FormControlLabel value="2" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For any ward in hospital" />
                                                                                <FormControlLabel value="1" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For user’s ward only" />
                                                                            </RadioGroup>
                                                                        </div>
                                                                        : null
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </FormGroup>
                                            }
                                            <FormGroup>
                                                <div style={{ borderLeft: '4px solid #000080', paddingLeft: 20, marginTop: 30 }}>
                                                    {currProfileCatId !== "SMA" ? <Heading text="Medical Response" color="#000080" /> : ""}
                                                    {
                                                        profileFeaturesList.filter(p => p.categoryName === "Medical Response" && p.appPermissionIsInternal === isInternal).map((perm, i) =>
                                                            <div>
                                                                <FormControlLabel
                                                                    key={i}
                                                                    control={<Checkbox name={perm.appPermDisplayName}
                                                                        style={{ padding: 4 }}
                                                                        checked={perm.checked ?? false}
                                                                        key={perm.applicationPermissionId}
                                                                        onChange={(e: React.ChangeEvent<any>) => toggleAdminCheckbox(e, perm.applicationPermissionId)} />}
                                                                    label={perm.appPermDisplayName}
                                                                />
                                                                <Description text={perm.appPermDescription} />
                                                                {
                                                                    perm.appPermissionRequireScope ?
                                                                        <div style={{ paddingLeft: 28 }}>
                                                                            <RadioGroup row value={perm.scope?.toString() ?? null} onChange={(e) => handleRadioChange(e, perm.applicationPermissionId)}>
                                                                                <FormControlLabel value="2" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For any ward in hospital" />
                                                                                <FormControlLabel value="1" control={<StyledRadio disabled={!perm.checked ?? true} />} label="For user’s ward only" />
                                                                            </RadioGroup>
                                                                        </div>
                                                                        : null
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </FormGroup>
                                        </TabPanel>
                                    </div>
                                </div>
                                : null
                        }
                        {body}
                    </div>
                </div>
            </div>
            <DeletePopUp
                isDialogOpen={confirmationDialog}
                onCancel={() => setConfirmationDialog(false)}
                onDo={deleteProfile}
                title="Delete profile"
                recordName="profile"
            />
        </React.Fragment>
    );
}

//export default UserProfile
export default React.memo(withRouter(UserProfile));